/* LINE 公式アカウント QR 弾窗（snippets/line-modal.liquid と対）
   - [data-line-modal] と本文中の line.me へのリンクのクリックを横取りして弾窗を開く（href は JS 無効時のフォールバック）
   - line.me へのリンクは当店アカウント（@747qnsmu）宛てのものだけを対象にする（他サイト・他アカウントは素通し）
   - /pages/kaitori へのリンクも買取用の弾窗にする。ただしヘッダーのナビ（.gnav と、同じメニューを使うスマホメニューのカテゴリ .sp-nav-cat）の「買取」だけは説明ページへ遷移させる
   - PC は中央ダイアログ、スマホ（≤768px）またはタッチ端末は下からのシート
   - 遮罩クリック・ESC・閉じるボタンで閉じる。開いている間は背景スクロールを止め、フォーカスを閉じ込め、閉じたら元の要素へ戻す */
(function () {
  'use strict';
  var root = document.getElementById('lineModal');
  if (!root) return;
  var box = root.querySelector('.lm-box');
  var kaitori = root.querySelector('[data-lm-kaitori]');
  var lastFocus = null, prevOverflow = '';
  var mqSmall = window.matchMedia ? window.matchMedia('(max-width: 768px)') : null;
  var mqCoarse = window.matchMedia ? window.matchMedia('(hover: none) and (pointer: coarse)') : null;

  /* 当店の LINE 公式アカウント宛て（line.me / サブドメイン、かつ @747qnsmu を含む）か */
  function isOwnLine(href) {
    if (!href) return false;
    var u;
    try { u = new URL(href, location.href); } catch (err) { return false; }
    var host = u.hostname.toLowerCase();
    if (host !== 'line.me' && !/\.line\.me$/.test(host)) return false;
    var full = u.pathname + u.search + u.hash;
    try { full = decodeURIComponent(full); } catch (err) { /* noop */ }
    return full.toLowerCase().indexOf('@747qnsmu') > -1;
  }
  function isSheet() { return !!((mqSmall && mqSmall.matches) || (mqCoarse && mqCoarse.matches)); }
  function focusables() {
    return [].slice.call(box.querySelectorAll('a[href], button:not([disabled])')).filter(function (el) {
      return el.offsetWidth > 0 || el.offsetHeight > 0;
    });
  }
  function open(trigger, forceScene) {
    lastFocus = trigger || document.activeElement;
    var scene = forceScene || (trigger && trigger.getAttribute('data-line-scene'));
    kaitori.hidden = scene !== 'kaitori';
    root.classList.toggle('lm--sheet', isSheet());
    root.hidden = false;
    prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    /* 表示後にアニメーション用クラスを付ける。rAF はタブが非表示だと止まり、透明な遮罩が残るため、強制リフローで即時に付ける */
    void root.offsetWidth;
    root.classList.add('is-open');
    var first = focusables()[0];
    (first || box).focus();
  }
  function close() {
    if (root.hidden) return;
    resetCopy();
    root.classList.remove('is-open');
    root.hidden = true;
    document.body.style.overflow = prevOverflow;
    if (lastFocus && lastFocus.focus) lastFocus.focus();
    lastFocus = null;
  }

  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest ? e.target.closest('[data-line-modal], a[href]') : null;
    if (!a || a.hasAttribute('data-line-direct') || root.contains(a)) return;
    var isLine = a.hasAttribute('data-line-modal') || isOwnLine(a.getAttribute('href'));
    var isKaitoriPage = false;
    if (!isLine) {
      if ((a.getAttribute('href') || '').charAt(0) === '#') return; /* ページ内リンク（本文へスキップ等）は対象外 */
      var u;
      try { u = new URL(a.href, location.href); } catch (err) { return; }
      isKaitoriPage = u.origin === location.origin && /\/pages\/kaitori\/?$/.test(u.pathname) && !a.closest('.gnav, .sp-nav-cat');
      if (!isKaitoriPage) return;
    }
    e.preventDefault();
    open(a, isKaitoriPage ? 'kaitori' : null);
  });
  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-lm-close]')) { close(); return; }
    var c = e.target.closest('[data-lm-copy]');
    if (c) copyId(c);
  });

  /* ---------- ID（@747qnsmu）のコピー ---------- */
  var copyBtn = root.querySelector('[data-lm-copy]');
  var copyLbl = root.querySelector('[data-lm-copy-lbl]');
  var copyStatus = document.getElementById('lmCopyStatus');
  var copyDefault = copyLbl ? copyLbl.textContent : '';
  var copyTimer;
  function copyResult(ok, msg) {
    clearTimeout(copyTimer);
    copyBtn.classList.toggle('is-done', ok);
    copyBtn.classList.toggle('is-fail', !ok);
    copyLbl.textContent = msg;
    copyStatus.textContent = '';
    /* 同じ文言でも読み上げさせるため一度空にしてから入れる */
    setTimeout(function () { copyStatus.textContent = ok ? '@747qnsmu をコピーしました' : msg; }, 30);
    copyTimer = setTimeout(resetCopy, ok ? 2000 : 4000);
  }
  function resetCopy() {
    if (!copyBtn) return;
    clearTimeout(copyTimer);
    copyBtn.classList.remove('is-done', 'is-fail');
    copyLbl.textContent = copyDefault;
    if (copyStatus) copyStatus.textContent = '';
  }
  function legacyCopy(btn) {
    /* ID のテキストを選択して execCommand('copy')（非 https・旧ブラウザ用） */
    var el = btn.querySelector('[data-lm-copy-text]');
    var sel = window.getSelection && window.getSelection();
    if (!el || !sel || !document.createRange) return false;
    var range = document.createRange();
    range.selectNodeContents(el);
    sel.removeAllRanges();
    sel.addRange(range);
    var ok = false;
    try { ok = document.execCommand && document.execCommand('copy'); } catch (err) { ok = false; }
    if (ok) sel.removeAllRanges(); /* 失敗時は選択状態を残し、長押しでコピーしやすくする */
    return !!ok;
  }
  function copyId(btn) {
    var text = btn.getAttribute('data-lm-copy');
    var done = function () { copyResult(true, 'コピーしました'); };
    var fallback = function () {
      if (legacyCopy(btn)) done();
      else copyResult(false, '長押しでコピーしてください');
    };
    if (navigator.clipboard && navigator.clipboard.writeText && window.isSecureContext !== false) {
      navigator.clipboard.writeText(text).then(done, fallback);
    } else {
      fallback();
    }
  }
  document.addEventListener('keydown', function (e) {
    if (root.hidden) return;
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key === 'Tab') {
      var f = focusables();
      if (!f.length) { e.preventDefault(); return; }
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && (document.activeElement === first || document.activeElement === box)) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });
  /* 画面幅が変わったら表示形式を合わせる */
  if (mqSmall && mqSmall.addEventListener) mqSmall.addEventListener('change', function () { if (!root.hidden) root.classList.toggle('lm--sheet', isSheet()); });

  window.SNKLine = { open: open, close: close };
})();
